import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_ACCOUNT_ELIGIBILITY } from 'actions/apiActionConstants'
import requestLoyaltyAccountEligibility from 'api/loyalty/requestLoyaltyAccountEligibility'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'

export function fetchLoyaltyAccountEligibility(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const memberId = state.auth.account.memberId
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const loyaltyEligibility = state.loyalty.eligibilityTier

    if (
      !getIsLoyaltyEnabled(state) ||
      !memberId ||
      hasLoyaltyAccount ||
      loyaltyEligibility.data ||
      loyaltyEligibility.fetching ||
      loyaltyEligibility.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ACCOUNT_ELIGIBILITY,
      request: () => requestLoyaltyAccountEligibility(memberId),
    })
  }
}

export default fetchLoyaltyAccountEligibility
